import { ReduxState } from "~/types/redux";
import { OfferMerchMetadata } from "~/types/offerObject";
import { arrayToKeyedObject } from "~/helpers/arrayToKeyedObject";
import { PlanCardsMetadata } from "~/types/products";
import { ToggleMobileView } from "~/constants/mobileProgress";

export const selectOfferMerchData = (state: ReduxState): OfferMerchMetadata | null => {
  return state.offerMerchData ?? null;
};

export const selectToggleMobileView = (state: ReduxState): ToggleMobileView | null => {
  return (selectOfferMerchData(state)?.productSelection?.toggleMobileView ?? null) as ToggleMobileView | null;
};

/**
 * Selector to get converted PlanCardsMetadata from offerMerchData.productCards
 * Converts the productCards array to a keyed object using productCardHash as the key
 */
export const selectPlanCardsMetadata = (state: ReduxState): PlanCardsMetadata | null => {
  const offerMerchData = selectOfferMerchData(state);
  if (!offerMerchData?.productCards) return null;

  const result = arrayToKeyedObject(offerMerchData.productCards, "productCardHash") as PlanCardsMetadata | null;

  return result;
};

/**
 * Selector factory to get aboveRTBTag by speed
 * @param speedInMbps - The download speed in Mbps (number, string, or undefined)
 * @returns A selector function that returns the aboveRTBTag for the given speed, or undefined if not found
 */
export const selectAboveRTBTag = (speedInMbps: number | string | undefined) => {
  return (state: ReduxState) => {
    if (!speedInMbps) return undefined;

    const planCardsMetadata = selectPlanCardsMetadata(state);
    if (!planCardsMetadata) return undefined;

    const speedKey = String(speedInMbps);
    return planCardsMetadata[speedKey]?.aboveRTBTag;
  };
};
